import { VITE_USE_MOCK, VITE_MOCK_API, VITE_IMAGE_READER_API } from 'Constants/appEnvConstants'

export default function getImageReaderBaseUrl() {
  return JSON.parse(VITE_USE_MOCK) ? VITE_MOCK_API : VITE_IMAGE_READER_API;
}
